module.exports = __webpack_public_path__ + "static/media/thumbnail.69af5de6.jpg";